import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.3_@types+node@20.11.25_eslint@8.57.0_rollup@2.79.1_typescript@5.4.2_vite@5.1.4_vue-tsc@1.8.27/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}